import { Component } from '@angular/core';

@Component({
  selector: 'app-dso-guard',
  templateUrl: './dso-guard.component.html',
  styleUrls: ['./dso-guard.component.scss']
})
export class DsoGuardComponent {

}
